import { render, staticRenderFns } from "./OrmBatchingView2.vue?vue&type=template&id=d1006f9c"
import script from "./OrmBatchingView2.vue?vue&type=script&lang=js"
export * from "./OrmBatchingView2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d1006f9c')) {
      api.createRecord('d1006f9c', component.options)
    } else {
      api.reload('d1006f9c', component.options)
    }
    module.hot.accept("./OrmBatchingView2.vue?vue&type=template&id=d1006f9c", function () {
      api.rerender('d1006f9c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ormbatching/OrmBatchingView2.vue"
export default component.exports